/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { Button } from 'react-bootstrap'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Select from 'react-select'
import { Table } from 'react-bootstrap-v5'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import { KTSVG } from '../../_metronic/helpers'
import PackingBomCreateModal from '../components/PackingBomCreateModal'

interface RouteParams {
	id: string;
}

interface InitialState {
	idProducts: number;
	productName: string;
	productCode: string;
	packing: string;
	size: string;
	unitName: string;
	itemUnitName: string;
}

interface FormulationItem {
	idPackingBomFormulations: number | null;
	idFormulationItems: number | null;
	itemName: string;
	categoryName: string;
	unitName: string;
	quantity: number | '';
	[key: string]: any;
}

interface PackingBomOption {
	label: string;
	value: number;
}

const emptyFormulationRow = (): FormulationItem => ({
	idPackingBomFormulations: null,
	idFormulationItems: null,
	itemName: '',
	categoryName: '',
	unitName: '',
	quantity: '',
})

function PackingBomFormulation() {
	const history = useHistory()
	const location = useLocation()
	const { id }: RouteParams = useParams()
	const [productionItems, setProductionItems] = useState<any[]>([])
	const initialState: InitialState = {
		idProducts: 0,
		productName: '',
		productCode: '',
		packing: '',
		size: '',
		unitName: '',
		itemUnitName: '',
	}

	const [formulationItems, setFormulationItems] = useState<FormulationItem[]>([emptyFormulationRow()])
	const [product, setProduct] = useState(initialState)
	const [packingBomOptions, setPackingBomOptions] = useState<PackingBomOption[]>([])
	const [selectedBom, setSelectedBom] = useState<PackingBomOption | null>(null)
	const [showBomCreateModal, setShowBomCreateModal] = useState(false)

	useEffect(() => {
		getAllProductionItems()
		getPackingBoms(id)
	}, [])

	useEffect(() => {
		if (selectedBom?.value) {
			getPackingBomFormulationData(id, selectedBom.value)
		}
	}, [selectedBom])

	const getPackingBoms = (idProducts: string) => {
		fetch(
			process.env.REACT_APP_API_URL + 'packing-boms/' + idProducts,
			getRequestOptions()
		)
			.then((resp) => resp.json())
			.then((resp) => {
				const options: PackingBomOption[] = (resp.data || []).map((bom: any) => ({
					label: bom.bom_name,
					value: bom.id_packing_boms,
				}))
				setPackingBomOptions(options)

				const query = new URLSearchParams(location.search)
				const idPackingBomFromUrl = query.get('id_packing_bom')
				const selected = idPackingBomFromUrl
					? options.find((option) => option.value === Number(idPackingBomFromUrl))
					: null
				const bomToSelect = selected || options[0] || null

				setSelectedBom(bomToSelect)
				if (bomToSelect && !idPackingBomFromUrl) {
					history.replace(`/packing-bom-formulation/${id}?id_packing_bom=${bomToSelect.value}`)
				}
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const handleBomChange = (option: PackingBomOption | null) => {
		if (!option) {
			return
		}
		setSelectedBom(option)
		history.replace(`/packing-bom-formulation/${id}?id_packing_bom=${option.value}`)
	}

	const handleBomCreated = (newBomId: number, bomName: string) => {
		const newOption: PackingBomOption = { label: bomName, value: newBomId }
		setPackingBomOptions((prev) => [...prev, newOption])
		setSelectedBom(newOption)
		history.replace(`/packing-bom-formulation/${id}?id_packing_bom=${newBomId}`)
	}

	const getPackingBomFormulationData = (idProducts: string, idPackingBoms: number) => {
		fetch(
			process.env.REACT_APP_API_URL + 'packing-bom-formulations/' + idProducts + '?id_packing_bom=' + idPackingBoms,
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				setProduct({
					idProducts: resp.data.idProducts,
					productName: resp.data.productName || '',
					productCode: resp.data.productCode || '',
					packing: resp.data.packing ?? '',
					size: resp.data.size ?? '',
					unitName: resp.data.unitName || '',
					itemUnitName: resp.data.itemUnitName || '',
				})
				const transformedItems = (resp.items || []).map((row: any) => ({
					...row,
					quantity: row.quantity === null || row.quantity === undefined || row.quantity === ''
						? ''
						: parseFloat(row.quantity),
				}))
				setFormulationItems(transformedItems.length ? transformedItems : [emptyFormulationRow()])
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const getAllProductionItems = () => {
		fetch(
			process.env.REACT_APP_API_URL + 'allProductionItems',
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				const items = resp.map((row: any) => {
					row.label = row.item_name
					row.categoryName = row.category_name
					row.value = row.id_items
					return row
				})
				setProductionItems(items)
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const savePackingBomFormulation = async (event: any) => {
		event.preventDefault()
		if (!selectedBom?.value) {
			Swal.fire({ icon: 'warning', title: 'Validation', text: 'Please select a BOM before saving.' })
			return
		}
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: 'You want to save this formulation?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Save it!',
		})
		if (confirm.value) {
			const requestOptions = postRequestOptions({
				items: formulationItems,
				idPackingBoms: selectedBom.value,
			})
			try {
				const response = await fetch(
					`${process.env.REACT_APP_API_URL}packing-bom-formulations/${id}`,
					requestOptions
				)
				const respData = await response.json()
				if (respData.success === true) {
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: respData.successMessage,
					})
				} else {
					const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
					Swal.fire({
						icon: 'error',
						title: 'Error',
						html: errorsMessage,
					})
				}
			} catch (error) {
				console.log(error, 'catch the hoop')
			}
		}
	}

	const addItem = () => {
		setFormulationItems([...formulationItems, emptyFormulationRow()])
	}

	const handleItemChange = (data: any, index: number) => {
		if (!data) {
			return
		}
		const updatedItems = [...formulationItems]
		updatedItems[index].idFormulationItems = data.value
		updatedItems[index].categoryName = data.categoryName
		updatedItems[index].unitName = data.unit_name
		setFormulationItems(updatedItems)
	}

	const handleItemDataChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
		const updatedItems = [...formulationItems]
		const { value } = e.target
		updatedItems[index].quantity = value === '' ? '' : value
		setFormulationItems(updatedItems)
	}

	const deleteItem = (index: number) => {
		const updatedItems = [...formulationItems]
		if (updatedItems && updatedItems[index]) {
			updatedItems.splice(index, 1)
			setFormulationItems(updatedItems)
		}
	}

	const sizeLabel = product.itemUnitName
		? `${product.size} ${product.itemUnitName}`
		: String(product.size ?? '')
	const packingLabel = product.itemUnitName
		? `${product.packing} ${product.itemUnitName}`
		: String(product.packing ?? '')

	return (
		<div className="card card-custom">
			<div className="card-header">
				<div className="card-title">
					<KTSVG path="/media/svg/icons/Text/Bullet-list.svg" className="svg-icon-1 svg-icon-primary" />
					<span className="text fw-bolder" style={{ marginLeft: '10px' }}>
						Packing BOM Formulation
					</span>
				</div>
			</div>

			<div className="card-body">
				<form onSubmit={savePackingBomFormulation}>
					<Table size="sm" bordered hover>
						<tbody>
							<tr>
								<td width={'30%'}>Product Name </td>
								<td width={'70%'}> : {product.productName}</td>
							</tr>
							<tr>
								<td>Code </td>
								<td> : {product.productCode}</td>
							</tr>
							<tr>
								<td>Packing </td>
								<td> : {packingLabel}</td>
							</tr>
							<tr>
								<td>Size </td>
								<td> : {sizeLabel}</td>
							</tr>
							<tr>
								<td>Unit </td>
								<td> : {product.unitName}</td>
							</tr>
							<tr>
								<td colSpan={2} className="text-end">
									<span className="d-inline-block me-2" style={{ minWidth: '220px', textAlign: 'left' }}>
										<Select
											value={selectedBom}
											onChange={(option: PackingBomOption | null) => handleBomChange(option)}
											options={packingBomOptions}
											placeholder="Select BOM"
											menuPosition="fixed"
											styles={{
												control: (provided) => ({
													...provided,
													height: '32px',
													minHeight: '32px',
												}),
												container: (provided) => ({
													...provided,
													height: '32px',
												}),
											}}
										/>
									</span>
									<Button type="button" variant="primary" size="sm" className="me-2" onClick={() => setShowBomCreateModal(true)}>
										<i className="fa fa-plus"></i> Create New BOM
									</Button>
									<Button type="button" variant="success" size="sm" onClick={() => addItem()}>
										<i className="fa fa-plus"></i> Add Item
									</Button>
								</td>
							</tr>
						</tbody>
					</Table>

					<Table size="sm" bordered hover>
						<thead>
							<tr>
								<th className="col-4">Item</th>
								<th className="col-3">Category</th>
								<th className="col-2">Quantity</th>
								<th className="col-2">Unit</th>
								<th className="col-1">Action</th>
							</tr>
						</thead>
						<tbody>
							{formulationItems.map((formulationItem, index) => (
								<tr key={'item' + index}>
									<td className="text-left">
										<Select
											value={productionItems.find((option) => option.value === formulationItems[index].idFormulationItems)}
											onChange={(selectedOption) => handleItemChange(selectedOption, index)}
											options={productionItems}
											className="sm"
											menuPosition="fixed"
											styles={{
												control: (provided) => ({
													...provided,
													height: '32px',
													minHeight: '32px',
												}),
												container: (provided) => ({
													...provided,
													height: '32px',
												}),
											}}
										/>
									</td>
									<td>{formulationItem.categoryName}</td>
									<td>
										<input
											type="number"
											name="quantity"
											min={0}
											step="any"
											value={formulationItem.quantity === 0 || formulationItem.quantity === '' || formulationItem.quantity == null ? '' : formulationItem.quantity}
											onChange={(event) => handleItemDataChange(event, index)}
											className="form-control form-control-sm"
										/>
									</td>
									<td>{formulationItem.unitName}</td>
									<td>
										<button type="button" className="btn btn-light-primary btn-sm px-2 py-1" onClick={() => deleteItem(index)}>
											<KTSVG path="/media/svg/icons/General/Trash.svg" className="svg-icon-5 svg-icon-danger me-0" />
										</button>
									</td>
								</tr>
							))}
						</tbody>
					</Table>

					<div className="form-group row">
						<div className="col text-center">
							<button type="submit" className="btn btn-sm btn-primary me-2"><span>  Save</span></button>
							<Button variant="secondary" size="sm" onClick={() => history.goBack()}>
								Close
							</Button>
						</div>
					</div>
				</form>
			</div>

			<PackingBomCreateModal
				show={showBomCreateModal}
				handleClose={() => setShowBomCreateModal(false)}
				product={{ idProducts: Number(id), productName: product.productName }}
				onCreated={handleBomCreated}
				existingBoms={packingBomOptions}
			/>
		</div>
	)
}

export default PackingBomFormulation
